module.exports = __webpack_public_path__ + "static/media/Penn Frame Red 2.7fe8f4f6.png";